




















import { Vue, Component } from 'vue-property-decorator';
// import { getAdapter, env } from '@zyf2e/adapt';

@Component
export default class MemberPaySuccess extends Vue {
  get orderInfo() {
    try {
      return JSON.parse(this.$route.query.orderInfo as string);
    } catch (e) {
      return {};
    }
  }

  // mounted() {
  //   const { backEventType } = this.orderInfo;
  //   console.log(this.orderInfo)
  //   if (Number(backEventType) === 1) {
  //     const adapt = getAdapter();
  //     console.log(adapt)
  //     if (env.inWechat) {
  //       setTimeout(() => {
  //         adapt.wx.closeWindow();
  //       }, 2000);
  //     }
  //   }
  // }

  handleBack() {
    window.location.replace(decodeURIComponent(this.orderInfo.homeUrl));
  }

  handleToOrder() {
    window.location.replace(decodeURIComponent(this.orderInfo.orderUrl));
  }
}
